import { createSlice } from '@reduxjs/toolkit';
import { ReturnsUpdateStateType } from 'src/types/returnsUpdate';

const initialState: ReturnsUpdateStateType = {
    loading: false,
    loadingMultiple: false,
};
export const returnsUpdateSlice = createSlice({
    name: 'returnsUpdate',
    initialState,
    reducers: {
        synchronizeReturnsDCIXFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        synchronizeReturnsDCIXFetchSuccess: (state, action) => {
            state.loadingMultiple = false;
        },
        synchronizeReturnsDCIXFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        },
        patchReturnFetch: (state, action) => {
            state.loading = true;
        },
        patchReturnFetchSuccess: (state) => {
            state.loading = false;
        },
        patchReturnFetchFailure: (state, action) => {
            state.loading = false;
            // Pokud chceš zpracovat chyby, můžeš je uložit do stavu
            // state.error = action.payload.error;
        },
        patchMultipleReturnsFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        patchMultipleReturnsFetchSuccess: (state) => {
            state.loadingMultiple = false;
        },
        patchMultipleReturnsFetchFailure: (state, action) => {
            state.loadingMultiple = false;
            // Pokud chceš zpracovat chyby, můžeš je uložit do stavu
            // state.errorMultiple = action.payload.error;
        }
    },
});

export const {
    synchronizeReturnsDCIXFetch,
    synchronizeReturnsDCIXFetchSuccess,
    synchronizeReturnsDCIXFetchFailure,
    patchReturnFetch,
    patchReturnFetchSuccess,
    patchReturnFetchFailure,
    patchMultipleReturnsFetch,
    patchMultipleReturnsFetchSuccess,
    patchMultipleReturnsFetchFailure
} = returnsUpdateSlice.actions;

export default returnsUpdateSlice.reducer;
